import { FC } from 'react';
import styled from 'styled-components';
import PlusIcon from './svg/PlusIcon';
import SubtractIcon from './svg/SubtractIcon';
import RoundButton from '@oberoninternal/travelbase-ds/components/action/RoundButton';
import { useMap } from 'react-map-gl';

const ZoomButtons: FC = () => {
    const map = useMap();
    return (
        <ZoomButtonsContainer>
            <RoundButton onClick={() => map.current?.zoomIn()} variant="outline">
                <PlusIcon />
            </RoundButton>
            <RoundButton onClick={() => map.current?.zoomOut()} variant="outline">
                <SubtractIcon width={18} height={18} />
            </RoundButton>
        </ZoomButtonsContainer>
    );
};

export default ZoomButtons;

const ZoomButtonsContainer = styled.div`
    position: absolute;
    right: 2.4rem;
    bottom: 2.4rem;
    flex-direction: column;
    display: none;
    > * + * {
        margin-top: 0.8rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.m}) {
        display: flex;
    }

    button {
        background: ${({ theme }) => theme.colors.neutral[0]};
    }
`;
